// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import elementUI from 'element-ui'

import Router from "vue-router"
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}


//ht
Vue.prototype.weTwoUrl = window.$url_front.weTwoUrl
Vue.prototype.weThreeUrl = window.$url_front.weThreeUrl
Vue.prototype.webSocketUrl = window.$url_front.webSocketUrl; //webSocket开发环境


Vue.use(elementUI);
Vue.config.productionTip = false;


new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js